import React from 'react';
import { SafeAreaView, ScrollView, StatusBar, Text } from 'react-native';
import translations from '@translations/ru.json';
import theme from '@const/theme';
import { styles } from './styles';

const texts = translations.privacy;

export const Rules = () => (
  <SafeAreaView style={styles.root}>
    <StatusBar barStyle="dark-content" backgroundColor="white" translucent />
    <ScrollView
      contentContainerStyle={styles.body}
      indicatorStyle={theme.indicatorStyle}
    >
      <Text style={styles.title}>{texts.title}</Text>
      <Text style={styles.text}>{texts.texts}</Text>
    </ScrollView>
  </SafeAreaView>
);
